module.exports = __webpack_public_path__ + "img/c_3.931fd449.png";